/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { CardGridGroup } from './CardGrid';
import './style.scss';

export default function SurveyGroupHeader({ group }: { group: CardGridGroup }) {
  if (!group.name) {
    return <></>;
  }

  return (
    <>
      <div className='border-top my-3' />
      <div className='survey-settings-toolbar mb-3 d-flex justify-content-between align-items-center'>
        <div className='survey-settings-toolbar-string strong p-1'>{group.name}</div>
        {group.component ? <group.component /> : null}
      </div>
    </>
  );
}
